import { render, staticRenderFns } from "./orderInvoiceDetails.vue?vue&type=template&id=48a0d281&scoped=true&"
import script from "./orderInvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./orderInvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderInvoiceDetails.vue?vue&type=style&index=0&id=48a0d281&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0d281",
  null
  
)

export default component.exports